import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../data/site';
import { Reveal } from './Reveal';
export function ContactBand() {
  return <section id="contact" className="border-t border-line py-24 lg:py-32" data-id="element-32" data-mp="1byixbsheofyh">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-33" data-mp="1gxvsr1mcevco">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-34" data-mp="1h0i133h25evy">
          <div className="lg:col-span-7" data-id="element-35" data-mp="128pmitp384va">
            <Reveal data-id="element-36" data-mp="127o94ikln6ae">
              <h2 className="font-display text-[clamp(2.25rem,5vw,4.5rem)] leading-[0.98] tracking-tight" data-id="element-37" data-mp="170r6l1shyzvv">
                Un projet neuf ou une
                <br data-id="element-38" data-mp="tae073v97t8n" />
                <span className="text-clay" data-id="element-39" data-mp="t6zvhoz4b7y1">rénovation</span> en tête ?
              </h2>
              <p className="mt-6 max-w-lg text-[15px] leading-relaxed text-graphite" data-id="element-40" data-mp="y5tajlu1z70b">
                Décrivez-moi votre projet, même à l’état d’idée. Je vous réponds avec les étapes, les délais et les
                autorisations d’urbanisme à prévoir.
              </p>
              <Link to="/contact" className="mt-10 inline-block bg-ink px-8 py-4 text-[11px] uppercase tracking-label text-paper transition-colors duration-150 ease-smooth hover:bg-clay" data-id="element-41" data-mp="2t8wgrvn2x2pi">
                Prendre contact
              </Link>
            </Reveal>
          </div>

          <div className="lg:col-span-4 lg:col-start-9" data-id="element-42" data-mp="2ya2fca3f7k6y">
            <Reveal delay={0.06} data-id="element-43" data-mp="2aiwufgimi1ps">
              <dl className="space-y-6 border-t border-line pt-6" data-id="element-44" data-mp="2ajy7trn430ao">
                <div className="flex gap-4" data-id="element-45" data-mp="25loelmky69rp">
                  <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-46" data-mp="25isf3ttgbd15" />
                  <div data-id="element-47" data-mp="2je4liygyyrxw">
                    <dt className="text-[11px] uppercase tracking-label text-graphite" data-id="element-48" data-mp="2eljug4pg6sy2">Téléphone</dt>
                    <dd className="mt-1" data-id="element-49" data-mp="1qvh6o0skg959">
                      <a href={contact.phoneHref} className="transition-colors duration-150 ease-smooth hover:text-clay" data-id="element-50" data-mp="1quec9iw1bokl">
                        {contact.phone}
                      </a>
                    </dd>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-51" data-mp="3qxp2dpeuf3s4">
                  <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-52" data-mp="3qwdx1l5r1nyw" />
                  <div data-id="element-53" data-mp="3vq03uwp8exms">
                    <dt className="text-[11px] uppercase tracking-label text-graphite" data-id="element-54" data-mp="3vqrwpzrg2h9d">Email</dt>
                    <dd className="mt-1 break-all" data-id="element-55" data-mp="4kgptmzr6ma4">
                      <a href={`mailto:${contact.email}`} className="transition-colors duration-150 ease-smooth hover:text-clay" data-id="element-56" data-mp="330t5pytowa22">
                        {contact.email}
                      </a>
                    </dd>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-57" data-mp="3hylhcfw48eaz">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-58" data-mp="s8hu2jpwfgjq" />
                  <div data-id="element-59" data-mp="x6t713bhq766">
                    <dt className="text-[11px] uppercase tracking-label text-graphite" data-id="element-60" data-mp="x607amay8hxj">Atelier</dt>
                    <dd className="mt-1 leading-relaxed" data-id="element-61" data-mp="2ho2c0ikoaulx">
                      {contact.address}
                      <br data-id="element-62" data-mp="2cr25k6jwvpua" />
                      {contact.city}
                    </dd>
                  </div>
                </div>
              </dl>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}